import type { UiMessageKey } from '../i18n/ui'

export type ValuationField = {
  name: string
  label: UiMessageKey
  required?: boolean
  type?: 'number' | 'text'
  min?: number
  max?: number
  options?: UiMessageKey[]
  autoComplete?: string
}
export const vehicleFields: ValuationField[] = [
  { name: 'make', label: 'sell.make', required: true },
  { name: 'model', label: 'sell.model', required: true },
  { name: 'version', label: 'sell.version', required: true },
  { name: 'year', label: 'sell.year', required: true, type: 'number', min: 1900, max: new Date().getFullYear() },
  { name: 'mileage', label: 'sell.mileage', required: true, type: 'number', min: 0, max: 2000000 },
  { name: 'plate', label: 'sell.plate' },
]
export const detailFields: ValuationField[] = [
  { name: 'fuel', label: 'sell.fuel', options: ['sell.petrol', 'sell.diesel', 'sell.hybrid', 'sell.electric', 'sell.lpg', 'sell.methane', 'sell.other'] },
  { name: 'gearbox', label: 'sell.gearbox', options: ['sell.manual', 'sell.automatic', 'sell.other'] },
  { name: 'engine', label: 'sell.engine', type: 'number', min: 0, max: 20000 },
  { name: 'power', label: 'sell.power', type: 'number', min: 0, max: 3000 },
  { name: 'doors', label: 'sell.doors', type: 'number', min: 1, max: 9 },
  { name: 'price', label: 'sell.price', type: 'number', min: 0, max: 10000000 },
  { name: 'color', label: 'sell.color' },
  { name: 'interior', label: 'sell.interior' },
  { name: 'condition', label: 'sell.condition' },
]
export const ownerFields: ValuationField[] = [
  { name: 'firstName', label: 'sell.firstName', required: true, autoComplete: 'given-name' },
  { name: 'lastName', label: 'sell.lastName', required: true, autoComplete: 'family-name' },
  { name: 'province', label: 'sell.province', required: true, autoComplete: 'address-level1' },
  { name: 'city', label: 'sell.city', autoComplete: 'address-level2' },
  { name: 'address', label: 'sell.address', autoComplete: 'street-address' },
]
export const valuationFields = [...vehicleFields, ...detailFields, ...ownerFields]
